'use strict';
import {EwSiteApp} from '../../app/ewsiteapp';

//EwSiteApp.requires.push('ngMessages');
//EwSiteApp.requires.push('flow');
//EwSiteApp.requires.push('ui.bootstrap');

//function modalRejectHandler(result){
//	console.log(result);
//}

EwSiteApp.controller('formSubmitCtrl', ['$scope', '$filter', '$log', '$uibModal', '$rootScope', '$timeout', 'ajaxSearch', 'SessionService', 'localStorageService', function ($scope, $filter, $log, $uibModal, $rootScope, $timeout, ajaxSearch, SessionService, localStorageService) {
		$scope.form_id = "";
		$scope.uploads_count = 0;
		$scope.total_upl = 0;
		$scope.uploaded_file = false;
		$scope.form;
		$scope.submitted = false;
		$scope.requiredFields = [];
		$scope.bad_address_length = 5;
		$scope.addresses_1 = [];
		$scope.findUrl = jsForms.findUrl;
		$scope.nodeId;
		$scope.value_textStoreToLs = {};
		$scope.choise_idStoreToLs = {};
		$scope.storedParams = {};
		$scope.storeParams = jsForms.storeParams;
		$scope.allowSaveList = jsForms.allowSaveList;
		$scope.choise_id = [];
		$scope.value_text = [];
		$rootScope.topCtrl = $scope;


		$scope.lsKey = function(){ return `forms_form_${$scope.nodeId}`; }

		function buildPayloadForStorage() {
			var out = {value_text: {}, choise_id: {}};
			angular.forEach($scope.value_text || {}, function (v, k) {
				if ((typeof $scope.allowSaveList[k] !== 'undefined' || $scope.allowSaveList[k]) &&
						v !== '' && v !== null && v !== undefined) {
					out.value_text[k] = v;
				}
			});

			angular.forEach($scope.choise_idStoreToLs || {}, function (v, k) {
				if ((typeof $scope.allowSaveList[k] !== 'undefined' || $scope.allowSaveList[k]) &&
						v !== '' && v !== null && v !== undefined) {
					out.choise_id[k] = v;
				}
			});

			angular.forEach($scope.choise_id || {}, function (v, k) {
				if (out.choise_id.hasOwnProperty(k))
					return;
				if (typeof $scope.allowSaveList[k] !== 'undefined' && !$scope.allowSaveList[k])
					return;
//				if (angular.isObject(v))
//					return;
				if (v === '' || v === null || v === undefined)
					return;
				out.choise_id[k] = v;
			});

			return out;
		}


		function applySavedToScope(saved) {
			if (!saved){
				return;
			}
			// value_text
			angular.forEach(saved.value_text || {}, function (v, k) {
				if (v !== '' && v !== null && v !== undefined) {
					$scope.value_text = $scope.value_text || {};
					$scope.value_text[k] = v;
				}
			});
		}

		$scope.saveToLocalStorage = function() {
			if (!$scope.storeParams){
				return;
			}
			console.log('key',$scope.lsKey())
			localStorageService.init($scope.lsKey(), {value_text: {}, choise_id: {}});
			localStorageService.setData(buildPayloadForStorage());
		};

		$scope.isSavedFormData = function () {
			return parseInt($scope.nodeId) > 0 && !!localStorage.getItem($scope.lsKey());
		};

		$scope.clearStorageData = function (e) {
			e.preventDefault();
			localStorageService.init($scope.lsKey(), {value_text: {}, choise_id: {}});
			localStorageService.clear();
		};

		$scope.setFormParamsFromLs = function (e) {
			e.preventDefault();
			if (!$scope.isSavedFormData()){
				return;
			}
			localStorageService.init($scope.lsKey(), {value_text: {}, choise_id: {}});
			var saved = localStorageService.getData();
			applySavedToScope(saved);

			$rootScope.$broadcast("dataUpdated", saved);
		};

		$scope.$on("dependentUpdated", function(event, data) {
			$timeout(function () {
				if($scope.isSavedFormData()){
					angular.forEach(data.value_text, function(value, key) {
						if(typeof($scope.value_text) !== 'undefined'){
							$scope.value_text[key] = value;
						}
					});
					angular.forEach(data.choise_id, function(value, key) {
						if(typeof($scope.choise_id) !== 'undefined'){
							$scope.choise_id[key] = value;
						}
					});
				}
				$rootScope.$broadcast("dependentUpdateDone");
			},500);
		});

		$scope.setFieldToLs = function (fieldId, value, name) {
			if (name === 'value_text') {
				if (value === undefined || value === null || value === '') {
					delete $scope.value_textStoreToLs[fieldId];
				} else {
					$scope.value_textStoreToLs[fieldId] = value;
				}
				return;
			}

			if (name === 'choise_id') {
				var v = (value && typeof value === 'object') ? value[fieldId] : value;

				if (v === undefined || v === null || v === '') {
					delete $scope.choise_idStoreToLs[fieldId];
				} else {
					$scope.choise_idStoreToLs[fieldId] = v;
				}
				return;
			}
		};


		$scope.formSubmit = function (e) {
			e.preventDefault();
			$scope.submitted = true;
			$scope.saveToLocalStorage();

			let is_grecaptcha = $scope.form.find('#g-recaptcha-response-hidden').length > 0;
			if (is_grecaptcha && typeof (grecaptcha) !== 'undefined') {
				grecaptcha.ready(function () {
					grecaptcha.execute($('#g-recaptcha-response-hidden').data('sitekey'), {action: 'submit'}).then(function (token) {
						if (document.getElementById('g-recaptcha-response-hidden')) {
							$('#g-recaptcha-response-hidden').val(token);
						} else {
							var inp = document.createElement('input');
							inp.type = 'hidden';
							inp.name = 'g-recaptcha-response';
							inp.value = token;
							$scope.form[0].appendChild(inp);
						}
						$scope.form[0].submit();
					});
				});
			} else {
				$scope.form[0].submit();
			}
		};
		$scope.changeState = function (field_id, state) {
			if (typeof ($scope.requiredFields['field_' + field_id]) !== 'undefined') {
				$scope.requiredFields['field_' + field_id].valid = state;
			}
		};

		$scope.addRequired = function (field_id) {
			if (typeof ($scope.requiredFields['field_' + field_id]) === 'undefined') {
				$scope.requiredFields['field_' + field_id] = {
					id: field_id,
					valid: false
				};
			}
			if (arguments[1] && typeof (arguments[1]) !== 'undefined') {
				$scope.requiredFields['field_' + field_id].parent_field_id = arguments[1];
			}
		};

		$scope.clearRequiredByChoiseId = function (parent_field_id) {
			let toRemove = [];
			for (let field in $scope.requiredFields) {
				if (typeof ($scope.requiredFields[field].parent_field_id) !== 'undefined') {
					if (parseInt($scope.requiredFields[field].parent_field_id) == parseInt(parent_field_id)) {
						toRemove[field] = $scope.requiredFields[field];
					}
				}
			}

			for (let rmField in toRemove) {
				delete $scope.requiredFields[rmField];
			}
		};

		$scope.requiredFieldsValid = function () {
			for (let file in $scope.requiredFields) {
				if (!$scope.requiredFields[file].valid) {
					return false;
				}
			}
			return true;
		};

		$scope.termsModal = function () {
			var template = 'forms/modal.html';
			var modalInstance = $uibModal.open({
				templateUrl: template,
				controller: 'formsPreviewCtrl',
				//size: 'sm',
				resolve: {
					item: function () {
						return $scope.rulesText;
					}
				}
			});

//		modalInstance.result.then(function(result){
//
//		}, modalRejectHandler);
		};

		$scope.getArrayField = function (form, name, field_id) {
			return form[name + '[' + field_id + ']'];
		};

		$scope.applyMessages = function (form, name) {
			return form[name] && form[name].$dirty && form[name].$invalid;
		};

		$scope.getArrayField = function (form, name) {
			return form[name];
		};

		SessionService.init();

		$scope.$on('$destroy', function () {
			SessionService.stop();
		});

	}]).directive('formSubmit', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);

			scope.rulesText = '';

			if (attr.rulesText && attr.rulesText !== '') {
				scope.rulesText = unescape(attr.rulesText);
			}
			if (attr.nodeId && attr.nodeId !== '') {
				scope.nodeId = attr.nodeId;
			}
		}
	};
});

EwSiteApp.directive('blockSpacesAndSymbols', function() {
  // matches every forbidden char:
  //  • whitespace
  //  • ~ ! # $ % ^ & * ( ) `
  //  • ALL Cyrillic (U+0400–U+04FF, U+0500–U+052F)
  //  • ALL Lithuanian letters ĄČĘĖĮŠŲŪŽąčęėįšųūž
  //  • comma ,  equals =  single-quote '  slash /  braces { }  question-mark ?  pipe |
  //  • angle-brackets < >  backslash \  square-brackets [ ]
  var forbiddenAll  = /[\s~!#$%^&*()`\u0400-\u04FF\u0500-\u052FĄČĘĖĮŠŲŪŽąčęėįšųūž,=\'\/\{\}\?\|<>\[\]\\]/g;
  var forbiddenTest = /[\s~!#$%^&*()`\u0400-\u04FF\u0500-\u052FĄČĘĖĮŠŲŪŽąčęėįšųūž,=\'\/\{\}\?\|<>\[\]\\]/;

  return {
    restrict: 'A',
    require: '?ngModel',
    link: function(scope, elem, attrs, ngModelCtrl) {
      // 1) BLOCK forbidden chars (and prevent two dots) on keydown
      elem.on('keydown', function(evt) {
        var k     = evt.key;
        var input = elem[0];
        var pos   = input.selectionStart;

        // block any single-character that's forbidden
        if (k.length === 1 && forbiddenTest.test(k)) {
          evt.preventDefault();
          return;
        }
        // block entering a second dot
        if (k === '.' && pos > 0 && input.value.charAt(pos - 1) === '.') {
          evt.preventDefault();
        }
      });

      // 2) CLEAN pasted text (strip forbidden + collapse multiple dots)
      elem.on('paste', function(event) {
        var e    = event.originalEvent || event;
        var clip = e.clipboardData
                   ? e.clipboardData.getData('text/plain')
                   : window.clipboardData
                     ? window.clipboardData.getData('Text')
                     : null;
        if (!clip) { return; }

        // if there's any forbidden chars or double-dots, strip/collapse them
        if (forbiddenTest.test(clip) || /\.\./.test(clip)) {
          event.preventDefault();

          // 1) remove all forbidden chars
          var cleaned = clip.replace(forbiddenAll, '');
          // 2) collapse any runs of dots into a single dot
          cleaned = cleaned.replace(/\.{2,}/g, '.');

          // splice the cleaned text into the input
          var input  = elem[0];
          var start  = input.selectionStart;
          var end    = input.selectionEnd;
          var val    = input.value;
          var newVal = val.slice(0, start) + cleaned + val.slice(end);

          input.value = newVal;
          if (ngModelCtrl) {
            ngModelCtrl.$setViewValue(newVal);
            ngModelCtrl.$render();
          }
        }
      });

      // 3) EXTRA SAFETY: sanitize anything that slips through
      if (ngModelCtrl) {
        ngModelCtrl.$parsers.unshift(function(viewVal) {
          if (!viewVal) { return viewVal; }
          // strip forbidden chars
          var stripped = viewVal.replace(forbiddenAll, '');
          // collapse any ".." into "."
          stripped = stripped.replace(/\.{2,}/g, '.');
          if (stripped !== viewVal) {
            ngModelCtrl.$setViewValue(stripped);
            ngModelCtrl.$render();
          }
          return stripped;
        });
      }
    }
  };
});

EwSiteApp.controller('formsPreviewCtrl', ['$scope', '$uibModalInstance', '$sce', 'item', function ($scope, $uibModalInstance, $sce, item) {
		$scope.rulesText = $sce.trustAsHtml(angular.copy(item));

		$scope.save = function () {
			$uibModalInstance.close($scope.rulesText);
		};
		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};
	}]);

EwSiteApp.controller('checkboxCtrl', ['$scope', '$timeout', '$filter', '$element',function ($scope, $timeout, $filter, $element) {
		$scope.fieldId = $element.attr("data-field-id");
		$scope.choise_id;

		$scope.setFieldToLs = function () {
			if ($element.attr("data-allow-save") == 1) {
				$scope.$root.topCtrl.setFieldToLs($scope.fieldId, $scope.choise_id, 'choise_id');
			}
		};

		$scope.initController = function (fieldId) {
			$scope.fieldId = fieldId;
			$scope.$parent.addRequired($scope.fieldId);
			$timeout(function () {
				$scope.choiseChanged();
			}, 50);
		};

		if ($element.attr("data-required") == 1) {
			$scope.initController($element.attr("data-field-id"));
		}


		$scope.choiseChanged = function () {
			let filter = $filter('filter')(Object.values($scope.choise_id[$scope.fieldId]), true, true);
			$scope.setFieldToLs();
			if (filter.length > 0) {
				$scope.$parent.changeState($scope.fieldId, true);
			} else {
				$scope.$parent.changeState($scope.fieldId, false);
			}
		};

		$scope.$on("dataUpdated", function(event, data) {
			var v = data && data.choise_id ? data.choise_id[$scope.fieldId] : undefined;
			if (typeof v !== 'undefined') {
				$scope.choise_id = $scope.choise_id || {};
				$scope.choise_id[$scope.fieldId] = v;
				$timeout(function () {
					$scope.choiseChanged();
				}, 50);
			}
		});

	}]);

EwSiteApp.controller('radioCtrl', ['$scope', '$timeout', '$element', function ($scope, $timeout, $element) {
		$scope.fieldId = $element.attr("data-field-id");
		$scope.choise_id;
		$scope.setFieldToLs = function () {
			if ($element.attr("data-allow-save") == 1) {
				var selected = ($scope.choise_id && $scope.choise_id[$scope.fieldId]) ? $scope.choise_id[$scope.fieldId] : null;
				$scope.$root.topCtrl.setFieldToLs($scope.fieldId, selected, 'choise_id');
			}
		};

		$scope.initController = function (fieldId) {
			$scope.fieldId = fieldId;
			$scope.$parent.addRequired($scope.fieldId);
			$timeout(function () {
				$scope.choiseChanged();
			}, 50);
		};

		if ($element.attr("data-required") == 1) {
			$scope.initController($element.attr("data-field-id"));
		}

		$scope.choiseChanged = function () {
			$scope.setFieldToLs();
			if ($scope.choise_id) {
				$scope.$parent.changeState($scope.fieldId, true);
			} else {
				$scope.$parent.changeState($scope.fieldId, false);
			}
		};

		$scope.$on("dataUpdated", function(event, data) {
			var v = data && data.choise_id ? data.choise_id[$scope.fieldId] : undefined;
			if (typeof v !== 'undefined') {
				$scope.choise_id = $scope.choise_id || {};
				$scope.choise_id[$scope.fieldId] = v;   // <-- keep it an object
				$timeout(function () {
					$scope.choiseChanged();
				}, 50);
			}
		});

	}]);

EwSiteApp.controller('dependentFieldCtrl', ['$scope', '$timeout', '$element', '$rootScope', function ($scope, $timeout, $element, $rootScope) {
		$scope.fieldId = $element.attr("data-field-id");
		$scope.choise_id;
		$scope.dependent_fields = {};
		let lastChoise;

		$scope.initController = function (fieldId) {
			$scope.fieldId = fieldId;
			$scope.$parent.addRequired($scope.fieldId);
			$timeout(function () {
				$scope.choiseChanged();
			}, 50);
		};

		$scope.setFieldToLs = function () {
			if ($element.attr("data-allow-save") == 1) {
				$scope.$root.topCtrl.setFieldToLs($scope.fieldId, $scope.choise_id, 'choise_id');
			}
		};

		if ($element.attr("data-required") == 1) {
			$scope.initController($element.attr("data-field-id"));
		}

		$scope.choiseChanged = function () {
			// Clear child select2 fields without resetting the parent
//			$timeout(function () {
//				$('.dependant-wrapper select').each(function () {
//					$(this).val(null).trigger('change');
//				});
//			}, 0);
			// Proceed with your logic to handle required fields and choices
			if (typeof ($scope.choise_id) !== 'undefined' && typeof ($scope.choise_id[$scope.fieldId]) !== 'undefined') {
				if(lastChoise != $scope.choise_id[$scope.fieldId]){
					$scope.$parent.clearRequiredByChoiseId($scope.fieldId);
				}
				lastChoise = $scope.choise_id[$scope.fieldId];

				// Handle dependent fields logic
				for (let dep_field of $scope.dependent_fields['c' + $scope.choise_id[$scope.fieldId]]) {

					dep_field.required = !!(dep_field.required == 1 || dep_field.required === true);
					if (dep_field.required) {
						$scope.$parent.addRequired(parseInt(dep_field.id), $scope.fieldId);
					}
				}
			}
			$scope.setFieldToLs();
			// Change the state of the parent field based on whether it has a selected value
			if (Array.isArray($scope.value_text)) {
				for (var i = 0; i < $scope.value_text.length; i++) {
					if ($scope.value_text[i]) {
						$scope.$parent.changeState(i, true);
					}
				}
			}

			if (Array.isArray($scope.choise_id)) {
				for (var i = 0; i < $scope.choise_id.length; i++) {
					if ($scope.choise_id[i]) {
						if (typeof $scope.choise_id[i] === 'object' && !Array.isArray($scope.choise_id[i])) {
							$scope.$parent.changeState(i, Object.values($scope.choise_id[i]).some(value => value === true));
						}
						else{
							$scope.$parent.changeState(i, true);
						}
					}
				}
			}
			else {
				if ($scope.choise_id) {
					$scope.$parent.changeState($scope.fieldId, true);
				} else {
					$scope.$parent.changeState($scope.fieldId, false);
				}
			}
		};

		$scope.$on("dependentUpdateDone", function(event, data) {
			$timeout(function () {
				$scope.choiseChanged();
			}, 50);
		});
		$scope.$on("dataUpdated", function(event, data) {
			var v = data && data.choise_id ? data.choise_id[$scope.fieldId] : undefined;

			if (typeof v !== 'undefined') {
				$scope.choise_id = $scope.choise_id || {};
				$scope.choise_id[$scope.fieldId] = v;
				$timeout(function () {
					$scope.choiseChanged();
				}, 50);
			}
			$rootScope.$broadcast("dependentUpdated", data);
		});


	}]);

EwSiteApp.controller('comparisonFieldCtrl', ['$scope', '$timeout', '$sce', function ($scope, $timeout, $sce) {
	$scope.fieldId = 0;
	$scope.field1 = 0;
	$scope.field2 = 0;
	$scope.condition = '';
	$scope.threshold = 0;
	$scope.message = '';
	$scope.showMessage = false;

	$scope.initController = function (fieldId, f1, f2, cond, thr, msg) {
		$scope.fieldId = fieldId;
		$scope.field1 = f1;
		$scope.field2 = f2;
		$scope.condition = cond;
		$scope.threshold = parseFloat(thr);
		$scope.message = $sce.trustAsHtml(msg);
		$scope.calculatedValue = '';
		$scope.$parent.addRequired($scope.fieldId);

		$timeout(function () {
			$scope.checkCondition();
		}, 500);

		$scope.$watch(function () {
			return $scope.$parent.value_text[$scope.field1];
		}, function (newValue) {
			$scope.checkCondition();
		});

		$scope.$watch(function () {
			return $scope.$parent.value_text[$scope.field2];
		}, function (newValue) {
			$scope.checkCondition();
		});
	};

	$scope.checkCondition = function () {
		var v1_val = $scope.$parent.value_text[$scope.field1];
		var v2_val = $scope.$parent.value_text[$scope.field2];

		// Handle undefined or empty
		if (typeof v1_val === 'undefined' || v1_val === '' || typeof v2_val === 'undefined' || v2_val === '') {
			$scope.showMessage = false;
			$scope.$parent.changeState($scope.fieldId, true);
			$scope.calculatedValue = '';
			$scope.value_text[$scope.fieldId] = '';
			return;
		}

		var v1_str = String(v1_val).replace(',', '.');
		var v2_str = String(v2_val).replace(',', '.');

		var v1 = parseFloat(v1_str);
		var v2 = parseFloat(v2_str);

		if (!isNaN(v1) && !isNaN(v2) && v1 >= 0 && v2 >= 0) {
			// Logic: Pmax = min(Field1, Field2)
			var pmax = Math.min(v1, v2);

			// Round to 2 decimal places
			pmax = Math.round(pmax * 100) / 100;

			// Display Pmax
			$scope.calculatedValue = pmax.toFixed(2).replace(',', '.');
			$scope.value_text[$scope.fieldId] = $scope.calculatedValue;

			var result = false;
			if ($scope.condition === '>') {
				result = pmax > $scope.threshold;
			} else if ($scope.condition === '<') {
				result = pmax < $scope.threshold;
			}
			$scope.showMessage = result;
			$scope.$parent.changeState($scope.fieldId, !result);
		} else {
			$scope.showMessage = false;
			$scope.$parent.changeState($scope.fieldId, true);
			$scope.calculatedValue = '';
			$scope.value_text[$scope.fieldId] = '';
		}
	};

}]);


EwSiteApp.controller('elasticSearchCtrl', ['$scope', '$timeout', '$log', 'ajaxSearch', function ($scope, $timeout, $log, ajaxSearch) {
		$scope.fieldId = 0;
		$scope.choise_id;
		$scope.uvis_address_id = null;
		$scope.findUrl = $scope.$parent.findUrl;
		$scope.uvis_address_required = false;
		$scope.show_bad_searches = false;
		$scope.noAddressFound = false;
		$scope.value_text = {};

		$scope.initController = function (fieldId, required) {
			$scope.fieldId = fieldId;
			$scope.uvis_address_required = required;
			if (required) {
				$scope.$parent.addRequired($scope.fieldId);
				$timeout(function () {
					$scope.addressChanged();
				}, 50);
			}
		};

		$scope.getFieldModel = function () {
			return $scope.value_text[$scope.fieldId];
		};

		$scope.findAddress = function () {
			$scope.uvis_address_id = null;
			$scope.addressChanged();
			if ($scope.findUrl !== '' && $scope.value_text[$scope.fieldId] != '') {
				$scope.loading = true;
				$scope.show_bad_searches = false;
				$scope.clearAddressSugggests();
				ajaxSearch.search($scope.findUrl, {address: $scope.value_text[$scope.fieldId]}).then(function (response) {
					if (response.success) {
						$scope.addresses = response.items;
						if ($scope.addresses.length > 0) {
							$scope.showSuggest = true;
							$scope.noAddressFound = false;
							$scope.show_bad_searches = false;
						} else {
							$scope.addresses = [];
							$scope.messages = response.messages;
							$scope.noAddressFound = true;
							$scope.showSuggest = false;

							/*$scope.number_bad_searches += 1;
							 if ($scope.number_bad_searches >= $scope.limit_bad_searches) {
							 $scope.show_bad_searches = true;
							 }*/
							if ($scope.value_text[$scope.fieldId] !== '' && $scope.value_text[$scope.fieldId].length >= $scope.$parent.bad_address_length) {
//							console.log($scope.value_text[$scope.fieldId].length, $scope.$parent.bad_address_length)
								$scope.show_bad_searches = true;
							}
						}
						$scope.loading = false;
					}
				}, function (response) {
					$log.error(response);
				});
			} else {
				$scope.clearAddressSugggests();
			}
		};

		$scope.setAddress = function (address) {
			$scope.uvis_address_id = address._source.adr_id;
			$scope.value_text[$scope.fieldId] = address._source.adr_sudetinis_adresas;
			$scope.addressChanged();
			$scope.clearAddressSugggests();
		};

		$scope.clearAddressSugggests = function () {
			$scope.showSuggest = false;
			$scope.addresses = [];
			$scope.messages = [];
		};

		$scope.addressChanged = function () {
			if ($scope.uvis_address_required && ($scope.value_text[$scope.fieldId] === 'undefined' || $scope.value_text[$scope.fieldId] === '')) {
				$scope.$parent.changeState($scope.fieldId, false);
				return;
			}

			if ($scope.value_text[$scope.fieldId] && $scope.value_text[$scope.fieldId] !== '') {
				$scope.$parent.changeState($scope.fieldId, true);
			}

		};
	}]);

